let menus = [
  {
    id: 1,
    name: "Hub",
    reportsTo: null,
    action: "View",
    menus: [
      {
        id: 11,
        name: "Information",
        reportsTo: 1,
        action: "View",
      },
      {
        id: 12,
        name: "Dashboard",
        reportsTo: 1,
        action: "View",
      },
      {
        id: 13,
        name: "Reports",
        reportsTo: 1,
        action: "View",
      },
    ],
  },

  {
    id: 2,
    name: "Org",
    reportsTo: null,
    action: "View",
    menus: [
      {
        id: 21,
        name: "Organization",
        reportsTo: 2,
        action: "View",
      },
      {
        id: 22,
        name: "Org Relationship",
        reportsTo: 2,
        action: "View",
      },
      {
        id: 23,
        name: "Org Hierarchy",
        reportsTo: 2,
        action: "View",
      },
    ],
  },

  {
    id: 3,
    name: "Team",
    reportsTo: null,
    action: "View",
    menus: [
      {
        id: 31,
        name: "User",
        reportsTo: 3,
        action: "View",
      },
      {
        id: 32,
        name: "Role",
        reportsTo: 3,
        action: "View",
      },
      {
        id: 33,
        name: "Access",
        reportsTo: 3,
        action: "View",
      },
      {
        id: 34,
        name: "Group",
        reportsTo: 3,
        action: "View",
      },
    ],
  },

  {
    id: 4,
    name: "Prod",
    reportsTo: null,
    action: "View",
    menus: [
      {
        id: 41,
        name: "Product",
        reportsTo: 4,
        action: "View",
      },
      {
        id: 42,
        name: "Product Variant",
        reportsTo: 4,
        action: "View",
      },
    ],
  },
];

export default menus;
